"use client";

import { usePathname } from "next/navigation";
import AppHeader from "app/new-home/new-home-page/src/header/AppHeader";
import AppHeaderOld from "app/new-home/old-home-page/src/header/AppHeader";
const AppHeaderABTest = () => {
  const pathname = usePathname();
  const isHomepage = pathname === "/" || pathname === "/home" || pathname === "/login" || pathname === "/ta-login" || pathname === "/about-us";
  const shouldUseOldHeader = Boolean(pathname) && !isHomepage;
  const isDetailPage = pathname?.startsWith("/detail");
  const headerComponent = <>{shouldUseOldHeader ? <AppHeaderOld /> : <AppHeader />}</>;
  if (isDetailPage) {
    return <div className='hidden md:block'>{headerComponent}</div>;
  }
  return headerComponent;
};
export default AppHeaderABTest;